export default function EmbedRatio() {
    document.querySelectorAll('iframe').forEach((e) => {
        if (e.parentNode.tagName === 'P') {
            e.parentNode.classList.add("ratio", "ratio-16x9");
        }
    });
}
